<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px"
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Avtividad:</h3>
          </v-col>

          <v-col cols="12" xl="8" md="8" sm="8" xs="12">
            <v-label>
              Nombre:
            </v-label>
            <p>{{ name }}</p>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="4" xs="12">
            <v-label>
              Tipo de actividad:
            </v-label>
            <p>{{ type_of_activity.name }}</p>
          </v-col>

          <v-col cols="12">
            <v-label>
              Descripción:
            </v-label>
            <p>{{ description }}</p>
          </v-col>
          
          <v-col cols="12" xl="4" md="4" sm="12">
            <v-label>
              Fecha de la actividad:
            </v-label>
            <p>{{ convertDate(date) }}</p>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12">
            <v-label>
              Hora de inicio:
            </v-label>
            <p>{{ start_time }}</p>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12">
            <v-label>
              Hora de finalización:
            </v-label>
            <p>{{ finish_time }}</p>
          </v-col>

          <v-col cols="12">
            <v-label>
              Público objetivo:
            </v-label>
            <p>{{ target_audience }}</p>
          </v-col>
          
          <v-col cols="12">

            <v-card
              max-width="380px"
              v-if="miniature"
              wei>
              <v-img
                contain
                :src="url_miniature"
                class="grey lighten-2"
                height="240px"
              >
              </v-img>
            </v-card> 

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'activitiesEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Cargando...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    
  </v-row>
</template>

<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'showActivityEdition',

    data: () => ({
      loading:true,
      loading_btn: false,
      loading_update:false,

      edition_id:null,
      activity_id: null,

      activity:[],

      name:null,
      description:null,
      date:'0000-00-00',
      start_time:null,
      finish_time: null,
      target_audience: null,

      miniature:null,
      url_miniature:null,

      type_of_activities:[],
      type_of_activity_id: null,
      type_of_activity:[],

      rules: [
        (value) =>
          !value ||
          value.size < 2 ||
          "El archivo es demaciado grande",
      ]
    }),

    methods:{
      async getTypeOfActivities()
      {
        await axios.get('type-of-activities').then(response =>{
          this.type_of_activities = response.data.data.type_of_activities
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },

      convertDate(date) {
        const parts = date.split('-');
        const day = parts[2];
        const month = parts[1];
        const year = parts[0];

        return `${day}/${month}/${year}`;
      },

      async getActivity()
      {
        await axios.get('admin/editions/'+this.edition_id+'/activities/'+this.activity_id).then(response =>{
          this.activity = response.data.data.activity
          this.name = this.activity.name
          this.description = this.activity.description
          this.date = this.activity.date
          this.start_time = this.activity.start_time
          this.finish_time = this.activity.finish_time
          this.target_audience = this.activity.target_audience
          this.miniature = this.activity.miniature
          this.type_of_activity_id = this.activity.type_of_activity_id
          this.type_of_activity = this.activity.type_of_activity
          this.url_miniature = APP_URL+ this.activity.miniature

          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },
    },
    created(){
      this.edition_id = this.$route.params.edition_id
      this.activity_id = this.$route.params.activity_id
      this.getTypeOfActivities().then(
        this.getActivity()
      )
    },
  }
</script>
